import * as React from "react";
import { PageProps } from "../Page";
import { IPortalFormDetailsPresenter } from "../../../presenter/portal/PortalFormDetailsPresenter";
import DisplayForm from "../../components/form/DisplayForm";
import { Typography, Divider } from "antd";

export interface Props extends PageProps {}
export interface State extends IPortalFormDetailsPresenter {}

export default class PortalFormDetailsPage extends React.Component<
  Props,
  State
> {
  private subscriptionId: number = 0;

  constructor(props: any) {
    super(props);
    this.state = { ...props };
  }

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe((result) => {
      return this.setState((prevState) => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }

  render() {
    const {
      translate,
      formSections,
      hasPdfAccess,
      pdfReportVisbile,
      generatePdfReport,
      pdfReportData,
      formVersion,
      applicant,
      selectedVersion,
      formType
    } = this.state;

    const { pdfReportLoader, portalFormDetailsLoader } = this.state.loaders;

    return (
      <div className={"page"}>
        <Typography.Title
          className={"form-details-title"}
          type={"secondary"}
          style={{ fontSize: 18 }}
        >
          {translate("portal.forms.form_details")}
        </Typography.Title>
        <Divider
          type={"horizontal"}
          style={{ marginTop: 10, marginBottom: 10 }}
        />
        {hasPdfAccess ? (
          <DisplayForm
            formSectionList={formSections}
            translate={translate}
            isEditableForm={false}
            isPreviousForm={true}
            isDraftFormVersion={() => false}
            loading={portalFormDetailsLoader}
            className={"display-form-container"}
            pdfReportVisible={pdfReportVisbile}
            generatePdfReport={generatePdfReport}
            pdfReportData={pdfReportData}
            pdfReportLoader={pdfReportLoader}
            selectedVersion={selectedVersion}
            applicant={applicant}
            formVersion={formVersion}
            formType={formType}
            allowedFileTypes=""
            isPortal={true}
          />
        ) : (
          <DisplayForm
            formSectionList={formSections}
            translate={translate}
            isEditableForm={false}
            isPreviousForm={true}
            isDraftFormVersion={() => false}
            loading={portalFormDetailsLoader}
            className={"display-form-container"}
            allowedFileTypes=""
            isPortal={true}
          />
        )}
      </div>
    );
  }
}
